import { createSlice } from "@reduxjs/toolkit";
import { fetchReports, createReportJob } from "./reportsThunks";

const reportsSlice = createSlice({
  name: "reports",
  initialState: {
    reports: [],
    total: 0,
    loading: false,
    error: null,
    filters: [],
    sortModel: [],
    currentPage: 1,
    pageSize: 20,
    hasMore: true,
  },
  reducers: {
    resetReportState(state) {
      state.loading = false;
      state.error = null;
    },
    setReportFilters(state, action) {
      state.filters = [...state.filters, ...action.payload];
      state.currentPage = 1;
      state.reports = [];
      state.hasMore = true;
    },
    setReportSortModel(state, action) {
      state.sortModel = action.payload;
      state.currentPage = 1;
      state.reports = [];
      state.hasMore = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReports.fulfilled, (state, action) => {
        state.loading = false;
        const { data, page } = action.payload;
        const reports = data.data;

        if (page === 1) {
          state.reports = reports;
        } else {
          state.reports = [...state.reports, ...reports];
        }

        state.currentPage = page;
        state.hasMore = reports.length === state.pageSize;
      })
      .addCase(fetchReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create & Download report
      .addCase(createReportJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createReportJob.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createReportJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetReportState, setReportFilters, setReportSortModel } =
  reportsSlice.actions;

export default reportsSlice.reducer;
